import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ItemsService} from '../commons/items.service';
import {PartnerGroup} from 'models/beans';

@Injectable({
    providedIn: 'root'
})
export class ProcessService extends ItemsService{


    constructor(public http2: HttpClient) {
        super(http2);
    }
    
    getServiceName(){
        return 'process';
    }
    getPartnerGroups() {
        return this.http2.get<any>(ItemsService.API_URL+'partnerGroup')
            .toPromise()
            .then(res => <PartnerGroup[]> res);
    }
    

}
